import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { ReactComponent as ArrowLeft } from 'assets/images/button-icons/ArrowLeft.svg'
import CustomButton from 'components/custom-button/CustomButton'
import myBusinessIcon from 'assets/images/comeFrom/myBusiness.svg'
import mvpIcon from 'assets/images/comeFrom/mvp.svg'
import forClientsIcon from 'assets/images/comeFrom/forClients.svg'
import exploringIcon from 'assets/images/comeFrom/exploring.svg'
import retailIcon from 'assets/images/comeFrom/features/retail.svg'
import financeIcon from 'assets/images/comeFrom/features/finance.svg'
import mediaIcon from 'assets/images/comeFrom/features/media.svg'
import tourismIcon from 'assets/images/comeFrom/features/tourism.svg'
import medicalIcon from 'assets/images/comeFrom/features/medical.svg'
import petIcon from 'assets/images/comeFrom/features/pet.svg'
import foodIcon from 'assets/images/comeFrom/features/food.svg'
import eventsIcon from 'assets/images/comeFrom/features/events.svg'
import beautyIcon from 'assets/images/comeFrom/features/beauty.svg'
import deliveryIcon from 'assets/images/comeFrom/features/delivery.svg'
import serviceIcon from 'assets/images/comeFrom/features/service.svg'
import realEstateIcon from 'assets/images/comeFrom/features/real-estate.svg'
import constructionIcon from 'assets/images/comeFrom/features/constructive.svg'
import fitnessIcon from 'assets/images/comeFrom/features/fitness.svg'
import nonProfitIcon from 'assets/images/comeFrom/features/no_profit.svg'
import educationIcon from 'assets/images/comeFrom/features/education.svg'
import automotiveIcon from 'assets/images/comeFrom/features/car.svg'
import legalIcon from 'assets/images/comeFrom/features/legal.svg'
import characterImage from 'assets/images/comeFrom/character.avif'
import leftCloud from 'assets/images/comeFrom/l-cloud.svg'
import rightCloud from 'assets/images/comeFrom/r-cloud.svg'
import { axiosInstance } from 'axiosInstance'
import { USER_URLS } from 'config/urls'
import { getClassNameForLanguage } from 'utils/common'
import { useTranslation } from 'react-i18next'
import { PATH_APPLICATIONS } from 'config/paths'

import './FromWhom.scss'
import FancyWord from 'components/fancy-word/FancyWord'

const options = [
    { key: 'buildBusiness', icon: myBusinessIcon },
    { key: 'launchMvp', icon: mvpIcon },
    { key: 'createClients', icon: forClientsIcon },
    { key: 'exploring', icon: exploringIcon },
]

const roleOptions = [
    { key: 'founder' },
    { key: 'marketing' },
    { key: 'productManager' },
    { key: 'developer' },
    { key: 'other' },
]

const industryOptions = [
    { key: 'retailEcommerce', icon: retailIcon },
    { key: 'financeInsurance', icon: financeIcon },
    { key: 'mediaContent', icon: mediaIcon },
    { key: 'travelHospitality', icon: tourismIcon },
    { key: 'healthcareMedical', icon: medicalIcon },
    { key: 'petServices', icon: petIcon },
    { key: 'foodRestaurant', icon: foodIcon },
    { key: 'eventsEntertainment', icon: eventsIcon },
    { key: 'beautyWellness', icon: beautyIcon },
    { key: 'logisticsDelivery', icon: deliveryIcon },
    { key: 'professionalServices', icon: serviceIcon },
    { key: 'realEstate', icon: realEstateIcon },
    { key: 'construction', icon: constructionIcon },
    { key: 'healthFitness', icon: fitnessIcon },
    { key: 'nonProfitChurch', icon: nonProfitIcon },
    { key: 'education', icon: educationIcon },
    { key: 'automotive', icon: automotiveIcon },
    { key: 'legal', icon: legalIcon },
]

const teamSizeOptions = [
    { key: 'justStarting' },
    { key: 'growing' },
    { key: 'established' },
    { key: 'large' },
]

const appBuilderOptions = [
    { key: 'adalo' },
    { key: 'glide' },
    { key: 'flutterFlow' },
    { key: 'bubble' },
    { key: 'hiredDevs' },
    { key: 'no' },
]

const FromWhom = () => {
    const history = useHistory()
    const { i18n, t } = useTranslation(['fromWhom'])
    const [step, setStep] = useState<1 | 2 | 3 | 4 | 5 | 6>(1)
    const [selectedOptions, setSelectedOptions] = useState<string[]>([])
    const [selectedRoles, setSelectedRoles] = useState<string[]>([])
    const [selectedIndustries, setSelectedIndustries] = useState<string[]>([])
    const [otherIndustry, setOtherIndustry] = useState('')
    const [selectedTeamSize, setSelectedTeamSize] = useState<string | null>(
        null,
    )
    const [selectedBuilders, setSelectedBuilders] = useState<string[]>([])
    const [isSubmitting, setIsSubmitting] = useState(false)
    const handleRoleToggle = (key: string) => {
        setSelectedRoles(prev =>
            prev.includes(key)
                ? prev.filter(item => item !== key)
                : [...prev, key],
        )
    }

    const handleOptionToggle = (key: string) => {
        setSelectedOptions(prev =>
            prev.includes(key)
                ? prev.filter(item => item !== key)
                : [...prev, key],
        )
    }

    const handleIndustryToggle = (key: string) => {
        setSelectedIndustries(prev =>
            prev.includes(key)
                ? prev.filter(item => item !== key)
                : [...prev, key],
        )
    }

    const handleBack = () => {
        if (step === 5) {
            setStep(4)
        } else if (step === 4) {
            setStep(3)
        } else if (step === 3) {
            setStep(2)
        } else if (step === 2) {
            setStep(1)
        }
    }

    const handleContinue = async () => {
        if (step === 1) {
            setStep(2)
            return
        }

        if (step === 2) {
            if (selectedRoles.length === 0) return
            setStep(3)
            return
        }

        if (step === 3) {
            setStep(4)
            return
        }

        if (step === 4) {
            if (!selectedTeamSize) return
            setStep(5)
            return
        }

        if (step === 5) {
            setStep(6)
            return
        }

        if (step === 6) {
            try {
                setIsSubmitting(true)

                const industries = [
                    ...selectedIndustries,
                    ...(otherIndustry.trim() ? [otherIndustry.trim()] : []),
                ]

                const payload = {
                    goals: selectedOptions,
                    roles: selectedRoles,
                    industries,
                    teamSize: selectedTeamSize || '',
                    previousBuilders: selectedBuilders,
                }

                await axiosInstance.put(USER_URLS.onboarding, payload)
                history.push(PATH_APPLICATIONS.create)
            } catch (error) {
                console.error('Error submitting onboarding form:', error)
            } finally {
                setIsSubmitting(false)
            }
        }
    }

    const handleBuilderToggle = (key: string) => {
        setSelectedBuilders(prev =>
            prev.includes(key)
                ? prev.filter(item => item !== key)
                : [...prev, key],
        )
    }

    return (
        <div className='from-whom'>
            <img
                src={leftCloud}
                alt=''
                aria-hidden
                className='from-whom__cloud from-whom__cloud--left'
            />
            <img
                src={leftCloud}
                alt=''
                aria-hidden
                className='from-whom__cloud from-whom__cloud--left-bottom'
            />
            <img
                src={rightCloud}
                alt=''
                aria-hidden
                className='from-whom__cloud from-whom__cloud--right'
            />
            <img
                src={leftCloud}
                alt=''
                aria-hidden
                className='from-whom__cloud from-whom__cloud--right-bottom'
            />
            <div className='from-whom__card'>
                <div className='circle from-whom__circleTop' />

                <div className='from-whom__steps' aria-hidden>
                    {Array.from({ length: 5 }).map((_, idx) => (
                        <span
                            // eslint-disable-next-line react/no-array-index-key
                            key={idx}
                            className={`from-whom__step-bar${
                                idx < step ? ' from-whom__step-bar--active' : ''
                            }`}
                        />
                    ))}
                </div>

                {step === 1 ? (
                    <div className='from-whom__step-content'>
                        <h4
                            className={`from-whom__title ${getClassNameForLanguage(
                                {
                                    i18n,
                                    uk: 'uk-bold',
                                    eng: 'eng-bold',
                                },
                            )}`}
                        >
                            {t('fromWhom:titlePrefix')}
                            <FancyWord
                                text={t('fromWhom:yourModuleQuestion')}
                                type='no-underline'
                            />
                        </h4>

                        <p
                            className={`from-whom__subtitle ${getClassNameForLanguage(
                                {
                                    i18n,
                                    uk: 'uk-regular',
                                    eng: 'eng-regular',
                                },
                            )}`}
                        >
                            {t('fromWhom:subtitle')}
                        </p>

                        <div className='from-whom__options'>
                            {options.map(option => (
                                <button
                                    key={option.key}
                                    type='button'
                                    className={`from-whom__option${
                                        selectedOptions.includes(option.key)
                                            ? ' from-whom__option--active'
                                            : ''
                                    }`}
                                    onClick={() =>
                                        handleOptionToggle(option.key)
                                    }
                                >
                                    <img src={option.icon} alt='' aria-hidden />
                                    <span
                                        className={`from-whom__option-label ${getClassNameForLanguage(
                                            {
                                                i18n,
                                                uk: 'uk-bold',
                                                eng: 'eng-bold',
                                            },
                                        )}`}
                                    >
                                        {t(`fromWhom:options.${option.key}`)}
                                    </span>
                                </button>
                            ))}
                        </div>

                        <div className='from-whom__actions'>
                            <CustomButton
                                design='secondary'
                                size='large'
                                handleClick={handleContinue}
                            >
                                {t('fromWhom:continue')}
                            </CustomButton>
                        </div>
                    </div>
                ) : step === 2 ? (
                    <div className='from-whom__step-content'>
                        <h1
                            className={`from-whom__title from-whom__title--role ${getClassNameForLanguage(
                                {
                                    i18n,
                                    uk: 'uk-bold',
                                    eng: 'eng-bold',
                                },
                            )}`}
                        >
                            {t('fromWhom:roleTitle')}
                        </h1>

                        <div className='from-whom__options'>
                            {roleOptions.map(option => (
                                <button
                                    key={option.key}
                                    type='button'
                                    className={`from-whom__option from-whom__option--role${
                                        selectedRoles.includes(option.key)
                                            ? ' from-whom__option--active'
                                            : ''
                                    }`}
                                    onClick={() => handleRoleToggle(option.key)}
                                >
                                    <span
                                        className={`from-whom__option-label ${getClassNameForLanguage(
                                            {
                                                i18n,
                                                uk: 'uk-bold',
                                                eng: 'eng-bold',
                                            },
                                        )}`}
                                    >
                                        {t(`fromWhom:roles.${option.key}`)}
                                    </span>
                                </button>
                            ))}
                        </div>

                        <div className='from-whom__actions from-whom__actions--role'>
                            <CustomButton
                                design='cancel'
                                size='large'
                                handleClick={handleBack}
                            >
                                <ArrowLeft />
                                {t('fromWhom:back')}
                            </CustomButton>

                            <CustomButton
                                design='secondary'
                                size='large'
                                handleClick={handleContinue}
                                disabled={selectedRoles.length === 0}
                            >
                                {t('fromWhom:continue')}
                            </CustomButton>
                        </div>
                    </div>
                ) : step === 3 ? (
                    <div className='from-whom__step-content'>
                        <h1
                            className={`from-whom__title from-whom__title--role ${getClassNameForLanguage(
                                {
                                    i18n,
                                    uk: 'uk-bold',
                                    eng: 'eng-bold',
                                },
                            )}`}
                        >
                            {t('fromWhom:industryTitle')}
                        </h1>

                        <div className='from-whom__industry-scroll'>
                            <div className='from-whom__industry-grid'>
                                {industryOptions.map(option => (
                                    <button
                                        key={option.key}
                                        type='button'
                                        className={`from-whom__industry-card${
                                            selectedIndustries.includes(
                                                option.key,
                                            )
                                                ? ' from-whom__industry-card--active'
                                                : ''
                                        }`}
                                        onClick={() =>
                                            handleIndustryToggle(option.key)
                                        }
                                    >
                                        <span
                                            className='from-whom__industry-icon'
                                            aria-hidden
                                        >
                                            <img src={option.icon} alt='' />
                                        </span>
                                        <span
                                            className={`from-whom__industry-label ${getClassNameForLanguage(
                                                {
                                                    i18n,
                                                    uk: 'uk-bold',
                                                    eng: 'eng-bold',
                                                },
                                            )}`}
                                        >
                                            {t(
                                                `fromWhom:industries.${option.key}`,
                                            )}
                                        </span>
                                    </button>
                                ))}
                            </div>
                        </div>

                        <input
                            type='text'
                            value={otherIndustry}
                            onChange={e => setOtherIndustry(e.target.value)}
                            placeholder={t('fromWhom:otherIndustryPlaceholder')}
                            className={`from-whom__industry-input ${getClassNameForLanguage(
                                {
                                    i18n,
                                    uk: 'uk-regular',
                                    eng: 'eng-regular',
                                },
                            )}`}
                        />

                        <div className='from-whom__actions from-whom__actions--role'>
                            <CustomButton
                                design='cancel'
                                size='large'
                                handleClick={handleBack}
                            >
                                <ArrowLeft />
                                {t('fromWhom:back')}
                            </CustomButton>

                            <CustomButton
                                design='secondary'
                                size='large'
                                handleClick={handleContinue}
                            >
                                {t('fromWhom:continue')}
                            </CustomButton>
                        </div>
                    </div>
                ) : step === 4 ? (
                    <div className='from-whom__step-content'>
                        <h1
                            className={`from-whom__title from-whom__title--role ${getClassNameForLanguage(
                                {
                                    i18n,
                                    uk: 'uk-bold',
                                    eng: 'eng-bold',
                                },
                            )}`}
                        >
                            {t('fromWhom:teamSizeTitle')}
                        </h1>

                        <div className='from-whom__options'>
                            {teamSizeOptions.map(option => (
                                <button
                                    key={option.key}
                                    type='button'
                                    className={`from-whom__team-option${
                                        selectedTeamSize === option.key
                                            ? ' from-whom__team-option--active'
                                            : ''
                                    }`}
                                    onClick={() =>
                                        setSelectedTeamSize(option.key)
                                    }
                                >
                                    <span
                                        className={`from-whom__team-option-title ${getClassNameForLanguage(
                                            {
                                                i18n,
                                                uk: 'uk-bold',
                                                eng: 'eng-bold',
                                            },
                                        )}`}
                                    >
                                        {t(
                                            `fromWhom:teamSizes.${option.key}.title`,
                                        )}
                                    </span>
                                    <span
                                        className={`from-whom__team-option-range ${getClassNameForLanguage(
                                            {
                                                i18n,
                                                uk: 'uk-regular',
                                                eng: 'eng-regular',
                                            },
                                        )}`}
                                    >
                                        {t(
                                            `fromWhom:teamSizes.${option.key}.range`,
                                        )}
                                    </span>
                                </button>
                            ))}
                        </div>

                        <div className='from-whom__actions from-whom__actions--role'>
                            <CustomButton
                                design='cancel'
                                size='large'
                                handleClick={handleBack}
                            >
                                <ArrowLeft />
                                {t('fromWhom:back')}
                            </CustomButton>

                            <CustomButton
                                design='secondary'
                                size='large'
                                handleClick={handleContinue}
                                disabled={!selectedTeamSize}
                            >
                                {t('fromWhom:continue')}
                            </CustomButton>
                        </div>
                    </div>
                ) : step === 5 ? (
                    <div className='from-whom__step-content'>
                        <h1
                            className={`from-whom__title from-whom__title--role ${getClassNameForLanguage(
                                {
                                    i18n,
                                    uk: 'uk-bold',
                                    eng: 'eng-bold',
                                },
                            )}`}
                        >
                            {t('fromWhom:buildersTitle')}
                        </h1>

                        <p
                            className={`from-whom__subtitle ${getClassNameForLanguage(
                                {
                                    i18n,
                                    uk: 'uk-regular',
                                    eng: 'eng-regular',
                                },
                            )}`}
                        >
                            {t('fromWhom:buildersSubtitle')}
                        </p>

                        <div className='from-whom__builders-grid'>
                            {appBuilderOptions.map(option => (
                                <button
                                    key={option.key}
                                    type='button'
                                    className={`from-whom__builder-option${
                                        selectedBuilders.includes(option.key)
                                            ? ' from-whom__builder-option--active'
                                            : ''
                                    }`}
                                    onClick={() =>
                                        handleBuilderToggle(option.key)
                                    }
                                >
                                    <span
                                        className={`from-whom__builder-option-label ${getClassNameForLanguage(
                                            {
                                                i18n,
                                                uk: 'uk-bold',
                                                eng: 'eng-bold',
                                            },
                                        )}`}
                                    >
                                        {t(`fromWhom:builders.${option.key}`)}
                                    </span>
                                </button>
                            ))}
                        </div>

                        <div className='from-whom__actions from-whom__actions--role'>
                            <CustomButton
                                design='cancel'
                                size='large'
                                handleClick={handleBack}
                            >
                                <ArrowLeft />
                                {t('fromWhom:back')}
                            </CustomButton>

                            <CustomButton
                                design='secondary'
                                size='large'
                                handleClick={handleContinue}
                            >
                                {t('fromWhom:getStarted')}
                            </CustomButton>
                        </div>
                    </div>
                ) : (
                    <div className='from-whom__step-content from-whom__step-content--summary'>
                        <h1
                            className={`from-whom__title from-whom__title--role ${getClassNameForLanguage(
                                {
                                    i18n,
                                    uk: 'uk-bold',
                                    eng: 'eng-bold',
                                },
                            )}`}
                        >
                            {t('fromWhom:summaryTitle')}
                        </h1>

                        <p
                            className={`from-whom__subtitle ${getClassNameForLanguage(
                                {
                                    i18n,
                                    uk: 'uk-regular',
                                    eng: 'eng-regular',
                                },
                            )}`}
                        >
                            {t('fromWhom:summarySubtitle')}
                        </p>

                        <img
                            src={characterImage}
                            alt=''
                            aria-hidden
                            className='from-whom__summary-image'
                        />

                        <div className='from-whom__summary-card'>
                            <div className='from-whom__summary-row'>
                                <span
                                    className={`from-whom__summary-label ${getClassNameForLanguage(
                                        {
                                            i18n,
                                            uk: 'uk-regular',
                                            eng: 'eng-regular',
                                        },
                                    )}`}
                                >
                                    {t('fromWhom:summaryLabels.intent')}
                                </span>
                                <span
                                    className={`from-whom__summary-value ${getClassNameForLanguage(
                                        {
                                            i18n,
                                            uk: 'uk-bold',
                                            eng: 'eng-bold',
                                        },
                                    )}`}
                                >
                                    {selectedOptions
                                        .map(item =>
                                            t(`fromWhom:options.${item}`),
                                        )
                                        .join(', ') || '-'}
                                </span>
                            </div>
                            <div className='from-whom__summary-row'>
                                <span
                                    className={`from-whom__summary-label ${getClassNameForLanguage(
                                        {
                                            i18n,
                                            uk: 'uk-regular',
                                            eng: 'eng-regular',
                                        },
                                    )}`}
                                >
                                    {t('fromWhom:summaryLabels.role')}
                                </span>
                                <span
                                    className={`from-whom__summary-value ${getClassNameForLanguage(
                                        {
                                            i18n,
                                            uk: 'uk-bold',
                                            eng: 'eng-bold',
                                        },
                                    )}`}
                                >
                                    {selectedRoles
                                        .map(item =>
                                            t(`fromWhom:roles.${item}`),
                                        )
                                        .join(', ') || '-'}
                                </span>
                            </div>
                            <div className='from-whom__summary-row'>
                                <span
                                    className={`from-whom__summary-label ${getClassNameForLanguage(
                                        {
                                            i18n,
                                            uk: 'uk-regular',
                                            eng: 'eng-regular',
                                        },
                                    )}`}
                                >
                                    {t('fromWhom:summaryLabels.industry')}
                                </span>
                                <span
                                    className={`from-whom__summary-value ${getClassNameForLanguage(
                                        {
                                            i18n,
                                            uk: 'uk-bold',
                                            eng: 'eng-bold',
                                        },
                                    )}`}
                                >
                                    {[
                                        ...selectedIndustries.map(item =>
                                            t(`fromWhom:industries.${item}`),
                                        ),
                                        otherIndustry.trim(),
                                    ]
                                        .filter(Boolean)
                                        .join(', ') || '-'}
                                </span>
                            </div>
                            <div className='from-whom__summary-row'>
                                <span
                                    className={`from-whom__summary-label ${getClassNameForLanguage(
                                        {
                                            i18n,
                                            uk: 'uk-regular',
                                            eng: 'eng-regular',
                                        },
                                    )}`}
                                >
                                    {t('fromWhom:summaryLabels.size')}
                                </span>
                                <span
                                    className={`from-whom__summary-value ${getClassNameForLanguage(
                                        {
                                            i18n,
                                            uk: 'uk-bold',
                                            eng: 'eng-bold',
                                        },
                                    )}`}
                                >
                                    {selectedTeamSize
                                        ? t(
                                              `fromWhom:teamSizes.${selectedTeamSize}.range`,
                                          )
                                        : '-'}
                                </span>
                            </div>
                            <div className='from-whom__summary-row'>
                                <span
                                    className={`from-whom__summary-label ${getClassNameForLanguage(
                                        {
                                            i18n,
                                            uk: 'uk-regular',
                                            eng: 'eng-regular',
                                        },
                                    )}`}
                                >
                                    {t('fromWhom:summaryLabels.previousTools')}
                                </span>
                                <span
                                    className={`from-whom__summary-value ${getClassNameForLanguage(
                                        {
                                            i18n,
                                            uk: 'uk-bold',
                                            eng: 'eng-bold',
                                        },
                                    )}`}
                                >
                                    {selectedBuilders
                                        .map(item =>
                                            t(`fromWhom:builders.${item}`),
                                        )
                                        .join(', ') || '-'}
                                </span>
                            </div>
                        </div>

                        <div className='from-whom__actions'>
                            <CustomButton
                                design='secondary'
                                size='large'
                                handleClick={handleContinue}
                                disabled={isSubmitting}
                            >
                                {t('fromWhom:done')}
                            </CustomButton>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default FromWhom
